/*jshint esversion: 6 */
import Home from "./UI/home.vue";
//import Experts from "./UI/experts.vue";
import About from "./UI/about.vue";
import PostView from "./UI/post-view.vue";
import Posts from "./UI/posts.vue";
import Contacts from "./UI/contacts.vue";
import Search from "./UI/search.vue";
import Events from "./UI/events.vue";
import multimedia from "./UI/multimedia.vue";
import ForMedia from "./UI/for-media.vue";
import PhotoAlbum from "./UI/photo-album.vue";
//import library from "./UI/library.vue";
import NotFound from "./UI/404.vue";
//import Tutor from "../../components/tutor/tutor.vue";
export default [
    {label:"Главная", icon:"home", path:"/", component: Home},
    //{label:"Эксперты", icon:"users", path:"/experts", component: Experts},
    {label:"Об ИМЭП", icon:"info", path:"/about", component: About},
    {label:"Публикации", icon:"info", path:"/posts", component: Posts},
    {label:"События", icon:"info", path:"/events", component: Events},
    {label:"Контакты", icon:"contacts", path:"/contacts", component: Contacts},
    //{label:"library", icon:"contacts", path:"/library", component: library},
    //{label:"TUTOR", icon:"tutor", path:"/tutor", component: Tutor},
    {label:"Для СМИ", icon:"media", path:"/for-media", component: ForMedia},
    {label:"Мультимедиа", icon:"video", path:"/multimedia", component: multimedia},
    {label:"Мультимедиа", icon:"video", path:"/multimedia/:mode", component: multimedia},
    {label:"Поиск", icon:"search", path:"/search", component: Search},
    {label:"Фото Альбом", icon:"search", path:"/photo-album/:id", component: PhotoAlbum},
    {path: '/posts/:id', component: PostView},
    { path: '/404', component: NotFound },  
    { path: '*', redirect: '/404' }, 
];


